import React from 'react';

import Divider from './Divider';

export default Divider;

export const Divider10 = ({ className }) => <Divider colorStep={10} className={className} />;
export const Divider70 = () => <Divider colorStep={70} />;
